var $export = require('./_export');
var $task = require('./_task');
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/web.immediate.js
 ** module id = 326
 ** module chunks = 23
 **/